import { render } from "./DigitalSignatureConfig.vue?vue&type=template&id=bbcafba2&scoped=true"
import script from "./DigitalSignatureConfig.vue?vue&type=script&lang=js"
export * from "./DigitalSignatureConfig.vue?vue&type=script&lang=js"

import "./DigitalSignatureConfig.vue?vue&type=style&index=0&id=bbcafba2&scoped=true&lang=css"
import "./DigitalSignatureConfig.vue?vue&type=style&index=1&id=bbcafba2&lang=css"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbcafba2"]])

export default __exports__